import { createContext, useContext, type ReactNode } from 'react';

/**
 * Identifies which section an <Editable> sits inside (so edits postMessage with
 * the right `sectionId`) AND exposes that section's live config, so an Editable
 * can read its persisted per-field style overrides (config.inlineStyles).
 * The admin parent uses the id to mutate the correct entry in `customSections`
 * before persisting the whole array back via the inline-edit endpoint.
 */
interface SectionContextValue {
  id: string | number | null;
  config: any | null;
}

const SectionContext = createContext<SectionContextValue>({ id: null, config: null });

export function SectionProvider({
  id,
  config,
  children,
}: {
  id: string | number | null | undefined;
  config?: any;
  children: ReactNode;
}) {
  return (
    <SectionContext.Provider value={{ id: id ?? null, config: config ?? null }}>
      {children}
    </SectionContext.Provider>
  );
}

export function useSectionId(): string | number | null {
  return useContext(SectionContext).id;
}

export function useSectionConfig(): any | null {
  return useContext(SectionContext).config;
}
